(function () {
  var MONTHS = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
  ];
  var WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  // True if a Saturday and/or Sunday falls anywhere between start and end
  // (inclusive) — doesn't matter if it's one weekend day or both, the caller
  // only ever adds a single day for it.
  function rangeContainsWeekend(start, end) {
    var d = new Date(start);
    while (d <= end) {
      if (isWeekend(d)) return true;
      d.setDate(d.getDate() + 1);
    }
    return false;
  }

  function formatDateWithWeekday(date) {
    return WEEKDAYS[date.getDay()] + ', ' + date.getDate() + '. ' + MONTHS[date.getMonth()];
  }

  function formatRange(minDate, maxDate) {
    return formatDateWithWeekday(minDate) + ' – ' + formatDateWithWeekday(maxDate);
  }

  // Orders placed before the 22:00 cutoff ship the same day; after that,
  // processing shifts one calendar day later. The countdown always shows
  // time remaining until whichever 22:00 cutoff is next (today or tomorrow),
  // so the sentence stays accurate around the clock, not just before 22:00.
  function update() {
    var dateEl = document.getElementById('ProductDeliveryEstimateDate');
    var countdownEl = document.getElementById('ProductDeliveryEstimateCountdown');
    if (!dateEl || !countdownEl) return;

    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(22, 0, 0, 0);

    var cutoffIsToday = now < cutoff;
    if (!cutoffIsToday) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    var shipDate = new Date(now);
    if (!cutoffIsToday) shipDate.setDate(shipDate.getDate() + 1);

    var minDate = addDays(shipDate, 2);
    var maxDate = addDays(shipDate, 4);

    // A weekend anywhere in the window pushes delivery back by one day —
    // one Saturday or a full Saturday+Sunday both just cost a single day.
    if (rangeContainsWeekend(minDate, maxDate)) {
      minDate = addDays(minDate, 1);
      maxDate = addDays(maxDate, 1);
    }

    // No parcel delivery on Sundays — a displayed Sunday would be a promise
    // that can't be kept, so either end of the window skips to Monday.
    if (minDate.getDay() === 0) minDate = addDays(minDate, 1);
    if (maxDate.getDay() === 0) maxDate = addDays(maxDate, 1);

    dateEl.textContent = formatRange(minDate, maxDate);

    var remainingMs = cutoff.getTime() - now.getTime();
    var remainingMinutesTotal = Math.max(0, Math.round(remainingMs / 60000));
    var hours = Math.floor(remainingMinutesTotal / 60);
    var minutes = remainingMinutesTotal % 60;

    var countdownParts = [];
    if (hours > 0) countdownParts.push(hours + ' Std.');
    if (minutes > 0 || hours === 0) countdownParts.push(minutes + ' Min.');
    countdownEl.textContent = countdownParts.join(' ');
  }

  function init() {
    update();
    setInterval(update, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
